import React, { FC } from 'react';
import _isArray from 'lodash/isArray';
import _map from 'lodash/map';
import FormikSearchWithDropdown from '@minecraft.formik-search-with-dropdown';
import SearchWithDropdown from '@minecraft.search-with-dropdown';
import { FilterData, SelectOption } from '../../../shared/types';

type Props = {
  searchByOptions: SelectOption[];
} & FilterData;

const SearchBy: FC<Props> = ({ name, label, searchByOptions }) => {
  return (
    <FormikSearchWithDropdown name={name} placeholder={label} aria-label={label}>
      {_map(searchByOptions, (option) => (
        <SearchWithDropdown.Option
          key={_isArray(option.value) ? option.value.join('_') : option.value}
          label={option.label}
          value={option.value}
          selectOthers={_isArray(option.value)}
        />
      ))}
    </FormikSearchWithDropdown>
  );
};

export default SearchBy;
